/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basket': {
    width: 23.202,
    height: 21.5,
    viewBox: '0 0 23.202 21.5',
    data: '<path pid="0" d="M23 7.088a.866.866 0 00-.661-.306h-2.4L15.219.353a.868.868 0 10-1.4 1.025l3.967 5.4h-12.6l3.967-5.4a.868.868 0 10-1.4-1.025l-4.72 6.429H.866A.866.866 0 00.012 7.79l2.164 12.987a.866.866 0 00.854.723h17.142a.865.865 0 00.854-.723L23.19 7.791a.866.866 0 00-.19-.703zm-3.558 12.68H3.763L1.888 8.517h19.427z" _fill="#959595"/><path pid="1" d="M11.601 10.534a.866.866 0 00-.866.866v5.685a.866.866 0 001.732 0V11.4a.866.866 0 00-.866-.866zM16.075 10.534a.866.866 0 00-.866.866v5.685a.866.866 0 101.731 0V11.4a.866.866 0 00-.865-.866zM7.128 10.534a.866.866 0 00-.866.866v5.685a.866.866 0 101.731 0V11.4a.866.866 0 00-.865-.866z" _fill="#959595"/>'
  }
})
